import { render, staticRenderFns } from "./SmartphoneComponent.vue?vue&type=template&id=b2008ffc&scoped=true&"
import script from "./SmartphoneComponent.vue?vue&type=script&lang=js&"
export * from "./SmartphoneComponent.vue?vue&type=script&lang=js&"
import style0 from "./SmartphoneComponent.vue?vue&type=style&index=0&id=b2008ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2008ffc",
  null
  
)

export default component.exports